module.exports = __webpack_public_path__ + "static/img/ios1.2.9e821ef9.jpg";